import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { getMetaPermissions } from './api';

/**
 * Get user Meta Permissions
 */
export const useQueryMetaPermission = () => {
    return useQuery({
        queryKey: QUERY_KEYS.metaPermission(),
        queryFn: getMetaPermissions,
    });
};
